'use client';

import { useCallback } from 'react';
import {
  PUSHER_CONNECTION_CALLBACK_TYPES,
  type PusherCallback,
  toPusherCallback,
} from '../../consts/pusher/callbacks';
import type { PusherClient } from '../../consts/pusher/sdk';

const CONNECTION_EVENTS: readonly { name: string; callbackType: string }[] = [
  { name: 'connected', callbackType: PUSHER_CONNECTION_CALLBACK_TYPES.connected },
  { name: 'disconnected', callbackType: PUSHER_CONNECTION_CALLBACK_TYPES.disconnected },
];

interface UsePusherConnectEventsParams {
  publishPusherCallback: (eventName: 'onPusherCallback', event: PusherCallback) => void;
  onConnectionError: () => void;
}

export function usePusherConnectEvents({
  publishPusherCallback,
  onConnectionError,
}: UsePusherConnectEventsParams) {
  const bindConnectEvents = useCallback(
    (client: PusherClient) => {
      for (const { name, callbackType } of CONNECTION_EVENTS) {
        client.connection.bind(name, (payload) => {
          publishPusherCallback('onPusherCallback', toPusherCallback(callbackType, payload));
        });
      }

      client.connection.bind('error', (payload) => {
        onConnectionError();
        publishPusherCallback(
          'onPusherCallback',
          toPusherCallback(PUSHER_CONNECTION_CALLBACK_TYPES.disconnected, payload),
        );
      });
    },
    [publishPusherCallback, onConnectionError],
  );

  return { bindConnectEvents };
}
